







import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({})
export default class ElsaFormError extends Vue {
  @Prop({ required: true, type: Boolean })
  active!: boolean
}
